import { useRef } from 'react'

const useScrollToBottom = () => {
    const scrollRef = useRef<HTMLDivElement>(null)

    const scrollToBottom = () => {
        setTimeout(() => {
            if (scrollRef.current) {
                scrollRef.current.scrollIntoView({ block: 'end' })
            }
        }, 1)
    }

    return { scrollRef, scrollToBottom }
}

export default useScrollToBottom
